// extracted by mini-css-extract-plugin
export default {"back_btn":"DashboardHeaderBtm_back_btn__JMa22","dashHeaderBtm":"DashboardHeaderBtm_dashHeaderBtm__aPWPc"};